module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_009.png?bcdfdaf29cc0ba522dacad33a054427f";